// @ts-check
import Vue from 'vue';

import './app';
import './components';

const rootElement = document.querySelector('#root');
const rootTemplate = '<bc-app />';

export default new Vue({
  el: rootElement,
  template: rootTemplate,
});



// WEBPACK FOOTER //
// ./src/index.js